// DAT-25 on GRW-15's Competitors / Teaming rows: "Mentor (SBA)" / "Protégé
// (SBA)" plus up to three certification badges, after the company name. The
// section calls useCompanySbaBadges once (batched) and passes each row its entry.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge, SpecraTooltip } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
const CERT_LABELS = {
    '8A': '8(a)',
    '8A_JV': '8(a) JV',
    HUBZONE: 'HUBZone',
    WOSB: 'WOSB',
    EDWOSB: 'EDWOSB',
    SDVOSB: 'SDVOSB',
    VOSB: 'VOSB',
    SDB: 'SDB'
};
export function SbaPursuitBadges({ badges }) {
    if (!badges || badges.mpRoles.length === 0 && badges.certCodes.length === 0) return null;
    const names = badges.mpCounterpartNames.join(', ');
    return /*#__PURE__*/ _jsxs("span", {
        className: "ml-2 inline-flex flex-wrap items-center gap-1",
        children: [
            badges.mpRoles.map((role)=>{
                const mentor = role === 'MENTOR';
                const tip = mentor ? `Mentor to ${names} — a mentor-protégé JV can bid set-asides the protégé qualifies for.` : `Protégé of ${names} — a mentor-protégé JV can bid set-asides the protégé qualifies for.`;
                return /*#__PURE__*/ _jsx(SpecraTooltip, {
                    content: tip,
                    placement: "top",
                    children: /*#__PURE__*/ _jsx("span", {
                        "data-testid": Testids.registrySba.pursuitMpBadge,
                        children: /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: "neutral",
                            children: mentor ? 'Mentor (SBA)' : 'Protégé (SBA)'
                        })
                    })
                }, role);
            }),
            badges.certCodes.slice(0, 3).map((c)=>/*#__PURE__*/ _jsx(SpecraBadge, {
                    variant: "neutral",
                    children: CERT_LABELS[c] ?? c
                }, c))
        ]
    });
}
